module.exports = __webpack_public_path__ + "static/media/12_tn.05f0d464.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/12_tn.jpg
// module id = 502
// module chunks = 0